import { AssessmentType, AssessmentTypeLabel } from 'components/Clinical/Assessments/constants'
import { AssessmentNames } from 'layouts/AssessmentLayout/constants'

export const getLabelForAssessmentType = (type: AssessmentType): string | null => {
  switch (type) {
    case AssessmentType.SOC:
      return AssessmentTypeLabel[AssessmentType.SOC]
    case AssessmentType.PAT:
      return AssessmentTypeLabel[AssessmentType.PAT]
    case AssessmentType.RECERT:
      return AssessmentTypeLabel[AssessmentType.RECERT]
    case AssessmentType.FUA:
      return AssessmentTypeLabel[AssessmentType.FUA]
    case AssessmentType.SUPERVISORY:
      return AssessmentTypeLabel[AssessmentType.SUPERVISORY]
    case AssessmentType.DISCHARGE:
      return AssessmentTypeLabel[AssessmentType.DISCHARGE]
    case AssessmentType.ROC:
      return AssessmentTypeLabel[AssessmentType.ROC]
    case AssessmentType.SERVICE_PLAN:
      return AssessmentTypeLabel[AssessmentType.SERVICE_PLAN]
    default:
      return null
  }
}

export const getNameForAssessmentType = (type: AssessmentType): string => {
  switch (type) {
    case AssessmentType.SOC:
      return AssessmentNames[AssessmentType.SOC]
    case AssessmentType.PAT:
      return AssessmentNames[AssessmentType.PAT]
    case AssessmentType.RECERT:
      return AssessmentNames[AssessmentType.RECERT]
    case AssessmentType.FUA:
      return AssessmentNames[AssessmentType.FUA]
    case AssessmentType.SUPERVISORY:
      return AssessmentNames[AssessmentType.SUPERVISORY]
    case AssessmentType.DISCHARGE:
      return AssessmentNames[AssessmentType.DISCHARGE]
    case AssessmentType.ROC:
      return AssessmentNames[AssessmentType.ROC]
    case AssessmentType.SERVICE_PLAN:
      return AssessmentNames[AssessmentType.SERVICE_PLAN]
    default:
      return ''
  }
}
